export default __webpack_public_path__ + "static/media/branding-logo.3d3ecbde.svg";